export function formatRecipeTime(minutesStr: string): string {
  const minutes: number = parseInt(minutesStr)

  if (isNaN(minutes)) {
    console.warn('Invalid input. Please provide a valid number of minutes.', minutesStr)
    return minutesStr
  }

  const hours: number = Math.floor(minutes / 60)
  const remainingMinutes: number = minutes % 60

  let result: string = ''

  if (hours > 0) {
    result += `${hours} ${hours === 1 ? 'hr' : 'hrs'} `
  }
  if (remainingMinutes > 0) result += `${remainingMinutes} mins`

  return result.trim()
}
